var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    fill: "none",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.646 7.047h8.334c.552 0 1.082.22 1.473.61.39.391.61.921.61 1.473v33.334c0 .552-.22 1.082-.61 1.473-.391.39-.92.61-1.473.61H6.48c-.553 0-1.083-.22-1.474-.61-.39-.39-.61-.92-.61-1.473V9.13c0-.552.22-1.082.61-1.473.391-.39.921-.61 1.474-.61h8.333V2.88h4.167v4.167h12.5V2.88h4.166v4.167zm6.25 16.667H8.563V40.38h33.333V23.714zm-10.416-12.5h-12.5v4.166h-4.167v-4.166h-6.25v8.333h33.333v-8.333h-6.25v4.166H31.48v-4.166zM12.73 27.88h4.166v4.167H12.73v-4.166zm10.416 0h4.167v4.167h-4.167v-4.166zm10.417 0h4.167v4.167h-4.167v-4.166z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d0be8b68d5a674d9e0f7840a1dd9b88e.svg";
export { ForwardRef as ReactComponent };